/**
 * Lo que ve el cliente cuando su solicitud ya esta guardada.
 *
 * **No lleva ni un numero, y no es porque falte trabajo.** La cotizacion la revisa un
 * asesor antes de que nadie vea un precio: es la regla de negocio del proyecto, la
 * misma que sigue el bot de WhatsApp. Lo que esta pantalla tiene que conseguir es que
 * la persona no se vaya a rellenar el formulario de la competencia mientras espera, y
 * eso se consigue diciendole que va a pasar y cuando, no enseñandole una cifra.
 */

interface Props {
  nombre: string
  contactoWhatsapp: string
  contactoEmail: string
  onOtra: () => void
}

export function Gracias({ nombre, contactoWhatsapp, contactoEmail, onOtra }: Props) {
  const soloNombre = nombre.trim().split(/\s+/)[0] ?? ''

  return (
    <section className="gracias" aria-live="polite">
      <div className="gracias-marca" aria-hidden="true">
        ☀
      </div>
      <h2>Listo{soloNombre && `, ${soloNombre}`}. Ya lo tenemos.</h2>

      <p className="gracias-principal">
        Estamos preparando tu propuesta. Un asesor de SunSmart va a revisar tu caso y se
        pone en contacto contigo para explicarte qué sistema te conviene y por qué.
      </p>

      <p className="gracias-secundario">
        Te enviamos un correo de confirmación. Preferimos que los números te los explique
        una persona: cada techo, cada consumo y cada horario son distintos, y un
        presupuesto automático se equivoca justo en lo que a ti te importa.
      </p>

      <div className="gracias-contacto">
        <p>¿Prefieres adelantar la conversación?</p>
        <a
          className="boton-whatsapp"
          href={`https://wa.me/${contactoWhatsapp.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Escríbenos por WhatsApp
        </a>
        <a href={`mailto:${contactoEmail}`}>{contactoEmail}</a>
      </div>

      <button type="button" className="boton-texto" onClick={onOtra}>
        Cotizar otra propiedad
      </button>
    </section>
  )
}
